import { PlayCircleOutlined, StopOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import { enableTemplateApi } from '@eastcoal/api/contract/template/enableTemplate'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useContractDesignerStore } from '../../Store/hooks/useStore'

export const EnableButton = () => {
  const { message } = useFeedback()
  const {
    formData: { id, enable },
    setTemplateEnable
  } = useContractDesignerStore(state =>
    pick(state, ['formData', 'setTemplateEnable'])
  )

  const realEnable = enable !== false

  const handleClick = async () => {
    const newEnable = !realEnable
    setTemplateEnable(newEnable)
    if (id) {
      await enableTemplateApi({
        id,
        enable: newEnable
      })
      message.success(newEnable ? '启用成功' : '停用成功', 1)
    }
  }

  return (
    <Button
      icon={realEnable ? <StopOutlined /> : <PlayCircleOutlined />}
      style={{ paddingInline: 4 }}
      type='text'
      onClick={handleClick}
    >
      {realEnable ? '停用' : '启用'}
    </Button>
  )
}
